import {store} from '../store'
import {subscriptionActions, userActions} from "../../_actions";

/*
 * This helper invokes all the tasks when the user access tokens are refreshed.
 */
export const reTokenizeActions = {
    launch
};

/**
 * Put all the necessary checks in the launch method
 */
function launch(){
    handleSubscriptionState();  // subscription-check
    handleUserInfo();           // user information and integrations
}

/**
 * This method invokes the subscription checks
 */
function handleSubscriptionState() {
    store.dispatch(subscriptionActions.getSubscription());
}

/**
 * This method invokes user information (including integrations)
 */
function handleUserInfo() {
    store.dispatch(userActions.fetchUser());
}